import {useState, useCallback, useEffect} from 'react';

import * as storage from '../utils/localStorage';

export default function useLocalStorage(key) {
  const [item, updateItem] = useState(storage.get(key));

  const syncState = useCallback(e => {
    if (e.key !== key || e.newValue === item) return;
    updateItem(storage.get(key));
  }, []);

  const setItem = useCallback(
    newValue => {
      if (newValue === item) return;
      updateItem(newValue);
      storage.set(key, newValue);
    },
    [item],
  );

  useEffect(() => storage.listen(syncState), [item]);

  return [item, setItem];
}
